import { API_BASE_URL } from './apiConfig';

export const loginAPI = async (username, password) => {
  const response = await fetch(`${API_BASE_URL}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Login failed. Please check your credentials.');
  }

  return data;
};

export const fetchProtectedData = async (role, token) => {
  const rolePath = role.toLowerCase();
  const response = await fetch(`${API_BASE_URL}/${rolePath}/data`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch protected data.');
  }

  return data;
};

export const fetchDashboardAPI = async (token) => {
  const response = await fetch(`${API_BASE_URL}/dashboard`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch dashboard data.');
  }

  return data;
};
